"use client";

export default function GlobalStyles() {
  return (
    <style jsx global>{`
      @keyframes changeBg {
        0%,
        100% {
          background-image: url("/heroimages/maldives.avif");
        }
        33% {
          background-image: url("/heroimages/mumbai.avif");
        }
        66% {
          background-image: url("/heroimages/paris.avif");
        }
      }
      .shadow-text {
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }
    `}</style>
  );
}
